<template>
  <div>
    <el-form
      :rules="rules"
      :model="receivedForm"
      ref="formedForm"
      label-position="top"
      label-width="120px"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="Дата" prop="date">
            <el-date-picker
              value-format="yyyy-MM-dd"
              format="dd.MM.yyyy"
              v-model="receivedForm.date"
              type="date"
              @change="setDatastored"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="ammount" label="" v-if="datastored !== null">
            Хранится на {{ receivedForm.date }} в данном структурном
            подразделении: {{ datastored.amount - datastored.sumAmountGet }}
            {{ datastored.pss93UnitInfo.name }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="2">
          <el-form-item label="">
            <el-radio
              :value="false"
              v-model="receivedForm.receivedFromPerson"
              :label="false"
              @change="changeRuleCIR"
            >
            -
            </el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="Контрагенты:" prop="contractorsInfoReceived">
            <el-select
              v-model="receivedForm.contractorsInfoReceived"
              :disabled="receivedForm.receivedFromPerson"
              style="width: 100%"
              value-key="id"
              clearable
              filterable
              placeholder="Выберите"
            >
              <el-option
                v-for="item in contractorsList"
                :key="item.id"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="2">
          <el-form-item label="">
            <el-radio
              v-model="receivedForm.receivedFromPerson"
              :label="true"
              @change="changeRuleCIR"
            >
              -</el-radio
            >
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="Физ. лица"> </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item prop="pss17Info" label="Поступило для:">
            <el-select
              clearable
              class="searchPole"
              value-key="id"
              v-model="receivedForm.pss17Info"
              filterable
              placeholder="Наименование причины"
            >
              <el-option
                v-for="item in pss17ReceiptReasonInfoList"
                :key="item.id"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Количество" prop="store">
            <el-input 
              v-model="receivedForm.store" 
              @input="receivedForm.store = receivedForm.store.replace(/[^0-9.,]/g, '')"
              :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Единица измерения">
            <el-input v-model="waste.pss93UnitInfo.name" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="Из них по импорту, количество" prop="number">
            <el-input v-model="receivedForm.importstore"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Единица измерения">
            <el-input v-model="waste.pss93UnitInfo.name" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-button
            @click="save"
            style="float: right"
            type="primary"
            :disabled="
              block ||
              GETISDATEENTRYLOCKED(receivedForm.date)
            "
            >Сохранить</el-button
          >
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import notification from "@/mixins/notification";
import Cookies from "js-cookie";
export default {
  name: "receivedModal",
  props: ["waste"],
  mixins: [notification],
  data() {
    return {
      pickerOptions:{
        firstDayOfWeek: 1
      },
      userId: Cookies.get("userId"),
      datastored: null,
      pss17ReceiptReasonInfoList: null,
      actionId: 2,
      receivedForm: {
        amount: this.waste.amount,
        store: null,
        date: "",

        contractorsInfoReceived: null,
        pss17Info: null,
        importstore: 0,
        receivedFromPerson: false,
      },

      rules: {
        store: [
          { required: true, message: "Введите количество", trigger: "blur" },
        ],

        amountExport: [
          { required: true, message: "Введите количество", trigger: "blur" },
        ],

        measurement: [
          {
            required: true,
            message: "Укажите единицу измерения",
            trigger: "blur",
          },
        ],

        pss17Info: [
          {
            required: true,
            message: "Заполните поле",
            trigger: "blur",
          },
        ],
        contractorsInfoReceived: [
          {
            required: true,
            message: "Заполните поле",
            trigger: "blur",
          },
        ],

        date: [{ required: true, message: "Введите дату", trigger: "blur" }],
      },
    };
  },

  computed: {
    ...mapGetters({
      contractorsList: "GETLISTCONTRACTORSSELECT",
      GETISDATEENTRYLOCKED: "GETISDATEENTRYLOCKED",
    }),
  },

  methods: {
    changeRuleCIR() {
      this.rules.contractorsInfoReceived[0].required =
        !this.receivedForm.receivedFromPerson;
    },

    async setDatastored() {
      await this.$store.dispatch("getBlockForUser",this.receivedForm.date).then((response) => {
        if(response.data == true)
          {
            this.block=true;
            this.message(
              "Внимание! Заблокировано главным экологом!",
              "error",
              true
            );
            return;
          }
      if (this.GETISDATEENTRYLOCKED(this.receivedForm.date))
        this.message(
          "Внимание! Внесение данных за " +
            new Date(this.validat().item.date).getFullYear() +
            " год ограничено. Закрыт отчетный период",
          "error",
          true
        );
      this.getDatastored().then((response) => {
        if (response.data == true) {
          this.block = true;
          this.message("Внимание! Цепочка устарела!", "error", true);
          return;
        }
        if (response.data == false) {
          this.block = true;
          this.message(
            "Внимание! Цепочка не начала действовать!",
            "error",
            true
          );
          return;
        }
        this.block = false;
        this.datastored = response.data;
      });
      
      });
    },
    async getDatastored() {
      let data = { date: "", techProcessHasWasteId: "" };
      data.date = this.receivedForm.date;
      data.techProcessHasWasteId = this.waste.techProcessHasWasteId;
      return await this.$store.dispatch("getDataStored", data);
    },
    getPss17ReceiptReasonInfoList() {
      this.getSubClassifierById(17).then((response) => {
        console.log(response.data);

        this.pss17ReceiptReasonInfoList = response.data.content;
      });
    },

    async getSubClassifierById(id) {
      let data = {
        id: id,
        size: 100,
        page: 0,
      };
      return await this.$store.dispatch(
        "getAllDataSubClassifierForSelect",
        data
      );
    },
    validat() {
      let i = 0;
      if (this.receivedForm.date == "" || this.receivedForm.store == "")
        //{this.ErrorMasseg("Внимание! Заполните всте поля");
        i = 1;
      if (this.GETISDATEENTRYLOCKED(this.receivedForm.date))
        //{this.ErrorMasseg("Внимание! Дата одного из значений меньше чем "+new Date().getFullYear()+" год");
        i = 2;
      return { id: i, item: this.receivedForm };
    },
    save: function () {
      switch (this.validat().id) {
        case 1:
          this.ErrorMasseg("Внимание! Заполните все поля");
          return;
        case 2:
          this.ErrorMasseg(
            "Внимание! Внесение данных за " +
              new Date(this.validat().item.date).getFullYear() +
              " год ограничено. Закрыт отчетный период"
          );
          return;
        case 0:
          break;
      }
      this.$refs["formedForm"].validate((valid) => {
        if (valid) {
          this.block = true;
          this.receivedForm.amount = this.waste.amount;

          console.log("VALID", this.receivedForm);
          if (this.receivedForm.receivedFromPerson) {
            this.receivedForm.contractorsInfoReceived = null;
          }
          this.$store
            .dispatch("receiveDataEntryForm", {
              modalData: this.receivedForm,
              id: this.$route.params.processId,
              actionId: this.actionId,
            })
            .then(() => {
              this.$store.dispatch(
                "getMainPageForDataEntry",
                this.$route.params.processId
              );
              this.$store.dispatch(
                "getMainPageForDataEntryByPeriod",
                this.$route.params.processId
              );
              this.notification("Успешно", "Данные внесены", "success");
              this.$store.dispatch("setShowModal", null);
              this.$store.dispatch("setShowModal", false);
            })
            .catch(error => {
              this.block = false;
              console.log(error.statusText);
            });
        } else {
          console.log("Не валид");
          console.log(this);
          return false;
        }
      });
    },
  },

  mounted() {
    this.$store.dispatch("getListContractors");
    this.getPss17ReceiptReasonInfoList();
  },
};
</script>

<style scoped></style>
